/**
 * A regular expression that enforces the following password policy:
 *   - At least 8 characters
 *   - At least one number
 *   - At least one special character
 *   - At least one uppercase letter
 *   - At least one lowercase letter
 */
export const PASSWORD_POLICY = /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])(?=.*[a-z]).{8,}$/;

export const URL_REGEX = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
